import axios from "axios";
import Swal from "sweetalert2";

export const handleVNPayReturn = async (
  setLoading,
  navigate,
  childrenAgeRule
) => {
  const urlParams = new URLSearchParams(window.location.search);
  const responseCode = urlParams.get("vnp_ResponseCode");
  const orderId = urlParams.get("vnp_TxnRef"); // Retrieve order ID

  if (responseCode) {
    setLoading(true);
    if (responseCode === "00") {
      try {
        console.log(`VNPay Transaction Successful. Order ID: ${orderId}`);
        const response = await axios.get(`/api/payment/vnpay/return`, {
          params: { vnp_TxnRef: orderId },
        });

        Swal.fire({
          title: "Success",
          text: "Your reservation was booked successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          const hotelInfo = response.data.hotelInfo; // Assume the backend returns hotel info
          const booking = response.data.booking; // Assume the backend returns booking details
          navigate("/confirmation", {
            state: { booking, hotelInfo, childrenAgeRule },
          });
        });
      } catch (error) {
        console.error(
          `Error verifying VNPay payment for Order ID: ${orderId}`,
          error
        );
        Swal.fire(
          "Error",
          "Failed to verify payment. Please contact support.",
          "error"
        );
      }
    } else {
      console.error(`VNPay Transaction Failed. Order ID: ${orderId}`);
      Swal.fire(
        "Payment Failed",
        "VNPay transaction failed. Please try again.",
        "error"
      );
    }
    setLoading(false);
  }
};
